<div class="modal-header" appCustomAutofocus>
    <h3 class="modal-title">Update Dependents</h3>
</div>
<div class="modal-body">
    <p>Now that you've updated your address, would you like to make that same change to your dependents?</p>
    <div>
        <ng-container *ngFor="let dependent of dependents">
            <div class="row" *ngIf="!dependent.IsPending">
                <div class="col-lg-offset-1"> </div>
                <div class="col-lg-1 col-md-3 col-sm-4">
                    <input type="checkbox" (change)="checkIfAnySelected()" style="width:25px;height:25px;" [(ngModel)]="dependent.selected" />
                </div>
                <div class="col-lg-10 col-md-9 col-sm-8">{{dependent.Name}}</div>
            </div>
        </ng-container>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-default" (click)="cancelClicked()">Do not update dependents</button>
    <button type="button" class="btn btn-success" [disabled]="!hasSelected" (click)="updateDependent()">Update Selected</button>
</div>